import Header from './components/Header';
import Hero from './components/Hero';
import FeaturedSection from './components/FeaturedSection';
import ScoopBoard from './components/ScoopBoard';
import VerifyDesk from './components/VerifyDesk';
import HowItWorks from './components/HowItWorks';
import FAQSection from './components/FAQSection';
import SubmitTip from './components/SubmitTip';
import Footer from './components/Footer';
import BackToTop from './components/BackToTop';

export default function Home() {
  return (
    <div className="min-h-screen bg-background-50 font-body">
      <Header />
      <main>
        <Hero />
        <FeaturedSection />
        <ScoopBoard />
        <VerifyDesk />
        <HowItWorks />
        <FAQSection />
        <SubmitTip />
      </main>
      <Footer />
      <BackToTop />
    </div>
  );
}